// @flow
import React, { useEffect, useState } from 'react';
// Styles
import './BigClubNotice.css';
// Components
import ProgressionBar from './ProgressionBar';
// Helpers
import { priceConverter } from '../../common';
// Types
type Props = {
  totalCartPrice: number,
  minPriceToEarnCashback: number,
};

const BigClubNotice = ({
  totalCartPrice = 0,
  minPriceToEarnCashback = 0,
}: Props) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  return (
    <div className="big-club-notice">
      {totalCartPrice >= minPriceToEarnCashback ? (
        <>
          <span className="big-club-notice-text">
            <span className="big-club-notice-text-orange-bold">Finalize sua compra</span>{' '}
            para garantir Cashback!
          </span>
        </>
      ) : (
        <>
          <span className="big-club-notice-text">
            Adicione <span className="big-club-notice-text-orange-bold"> {' '} {priceConverter(minPriceToEarnCashback - totalCartPrice)}{' '}</span>  para garantir o 
            <span className="big-club-notice-text-orange-bold"> {' '} Cashback!</span>
          </span>
        </>
      )}
      {windowWidth > 740 && <ProgressionBar
        absoluteValueToCompare={minPriceToEarnCashback}
        valueToBeCompared={totalCartPrice}
        barColor="linear-gradient(90deg, #CE3C25 0%, #EB5B1E 57.81%)"
        backgroundbarColor='#EAD3CF'
      />}
    </div>
  );
};

export default BigClubNotice;
